import { nb } from "date-fns/locale";
import { t } from "i18next";
import ReactDatePicker from "react-datepicker";

import styles from "./DateRangePicker.module.css";

/**
 * @deprecated Use DateRangeInput from ui-components instead
 */

interface DateRangePickerProps {
  startDate: Date | undefined | null;
  endDate: Date | undefined | null;
  showTimeSelect?: boolean;
  setStartDate: (e: Date | null) => void;
  setEndDate: (e: Date | null) => void;
  minDate?: Date;
  timeIntervals?: number;
  timeSelectOnly?: boolean;
  className?: string;
}

/**
 * @deprecated use AriaDateRangePicker instead
 */
export const DateRangePicker = (props: DateRangePickerProps) => {
  const currentYear = new Date().getUTCFullYear();
  const showYear = currentYear !== props.startDate?.getUTCFullYear() || currentYear !== props.endDate?.getUTCFullYear();
  const yearFormat = props.timeSelectOnly ? "" : "d. MMM" + (showYear ? " yyyy" : "");
  const dateFormat = props.showTimeSelect ? "HH:mm (" + yearFormat + ")" : yearFormat;

  let className = styles.container;
  if (props.className) className = className + " " + props.className;

  return (
    <div className={className}>
      <ReactDatePicker
        selected={props.startDate}
        onChange={(date) => props.setStartDate(date as Date)}
        selectsStart
        startDate={props.startDate}
        endDate={props.endDate}
        minDate={props.minDate}
        placeholderText={t("main.startDate")}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        locale={nb}
        calendarStartDay={1}
        timeIntervals={props.timeIntervals ?? 30}
        dateFormat={dateFormat}
        showTimeSelect={props.showTimeSelect}
        showTimeSelectOnly={props.timeSelectOnly}
      />
      <i className="material-icons">keyboard_arrow_right</i>
      <ReactDatePicker
        selected={props.endDate}
        onChange={(date) => props.setEndDate(date as Date)}
        selectsEnd
        startDate={props.startDate}
        endDate={props.endDate}
        minDate={props.startDate}
        placeholderText={t("main.endDate")}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        locale={nb}
        calendarStartDay={1}
        timeIntervals={props.timeIntervals ?? 30}
        dateFormat={dateFormat}
        showTimeSelect={props.showTimeSelect}
        popperPlacement="bottom-end"
        showTimeSelectOnly={props.timeSelectOnly}
      />
    </div>
  );
};

